import type { LucideIcon } from 'lucide-react';

import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';

/**
 * COMPATIBILITY SHIM — legacy EmptyState API over shadcn's Empty.
 *
 * `icon` stays a component reference (LucideIcon) rather than an element, which
 * is what the 21 call sites pass; EmptyMedia wants an element, so it is
 * instantiated here.
 */

interface Props {
  icon: LucideIcon;
  title: string;
  description?: string;
  ctaLabel?: string;
  onCtaClick?: () => void;
  style?: React.CSSProperties;
  className?: string;
}

export default function EmptyState({
  icon: Icon,
  title,
  description,
  ctaLabel,
  onCtaClick,
  style,
  className,
}: Props) {
  return (
    <Empty role="status" className={cn('rounded-xl border bg-card', className)} style={style}>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Icon />
        </EmptyMedia>
        <EmptyTitle className="font-heading">{title}</EmptyTitle>
        {description && <EmptyDescription>{description}</EmptyDescription>}
      </EmptyHeader>
      {ctaLabel && onCtaClick && (
        <EmptyContent>
          <Button onClick={onCtaClick}>{ctaLabel}</Button>
        </EmptyContent>
      )}
    </Empty>
  );
}
